var map = {
	"./blockColors/blockColors.jsx": "./src/editor-settings/settings/blockColors/blockColors.jsx",
	"./cascadeProcedureColors/cascadeProcedureColors.jsx": "./src/editor-settings/settings/cascadeProcedureColors/cascadeProcedureColors.jsx",
	"./disableExpandables/disableExpandables.jsx": "./src/editor-settings/settings/disableExpandables/disableExpandables.jsx",
	"./hexagonalRoundness/hexagonalRoundness.jsx": "./src/editor-settings/settings/hexagonalRoundness/hexagonalRoundness.jsx",
	"./paintMultiTool/paintMultiTool.jsx": "./src/editor-settings/settings/paintMultiTool/paintMultiTool.jsx",
	"./paintScrollZoom/paintScrollZoom.jsx": "./src/editor-settings/settings/paintScrollZoom/paintScrollZoom.jsx",
	"./showExtensionIds/showExtensionIds.jsx": "./src/editor-settings/settings/showExtensionIds/showExtensionIds.jsx",
	"./splashModal/splashModal.jsx": "./src/editor-settings/settings/splashModal/splashModal.jsx",
	"./swatches/swatches.jsx": "./src/editor-settings/settings/swatches/swatches.jsx",
	"./test/test.jsx": "./src/editor-settings/settings/test/test.jsx",
	"./vmDebug/vmDebug.jsx": "./src/editor-settings/settings/vmDebug/vmDebug.jsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/editor-settings/settings sync recursive ^\\.\\/.*\\.jsx$";